module.exports = __webpack_public_path__ + "img/workwithus-hero.a28a7965.jpg";